export const wordOf = (dec: number) => ({
  dec,
  hex: dec.toString(16).padStart(4, '0')
})

export function setPath(obj: any, path: string[], value: any): any {
  if (path.length === 1) return { ...obj, [path[0]]: value }
  return { ...obj, [path[0]]: setPath(obj[path[0]], path.slice(1), value) }
}

export function getPath(obj: any, path: string[]): any {
  return path.reduce((acc, key) => acc?.[key], obj)
}
